var _path, _g, _path2, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtusdn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_25",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 243,
    height: 242
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.021 98.7239C229.786 90.7681 212.459 86.27 194.082 86.27C133.218 86.27 83.878 135.61 83.878 196.474C83.878 213.507 87.742 229.636 94.6408 244.035C41.9583 230.353 3.06122 182.474 3.06122 125.51C3.06122 57.8836 57.8835 3.06128 125.51 3.06128C183.936 3.06128 232.805 43.9804 245.021 98.7239Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.082 21.4286C58.4346 21.4286 21.4286 58.4322 21.4286 104.081C21.4286 149.727 58.4346 186.735 104.082 186.735C149.729 186.735 186.735 149.727 186.735 104.081C186.735 58.4322 149.729 21.4286 104.082 21.4286Z",
    fill: "#4EAF94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.725 145.408V113.231C132.357 112.149 147.129 107.448 147.13 101.817C147.13 96.1865 132.357 91.4863 112.726 90.4035L112.725 81.4299H137.237V62.7551H70.2131V81.4299H94.7217V90.4467C75.4499 91.6047 61.0332 96.2544 61.0332 101.817C61.0332 107.38 75.4499 112.03 94.7217 113.187V145.408H112.725ZM112.726 103.368V92.4441C129.631 93.2192 142.233 96.2195 142.233 99.8067C142.233 103.982 125.152 107.366 104.082 107.366C83.0103 107.366 65.9293 103.982 65.9293 99.8067C65.9293 96.2719 78.1773 93.3037 94.7226 92.4781V94.605H94.7244V103.327C97.7064 103.498 100.842 103.591 104.081 103.591C107.062 103.591 109.957 103.511 112.726 103.368Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.571 195.918L195.918 113.265L113.265 195.918L195.918 278.572L278.571 195.918ZM198.878 248.905H191.775V238.606C177.687 237.363 166.026 229.017 165.612 215.225H175.912C176.971 222.58 181.479 228.179 191.587 229.352C194.865 229.939 197.764 229.8 200.159 229.311C210.22 228.172 214.15 222.946 214.15 216.409C214.15 209.899 210.953 205.755 199.233 202.914L198.878 202.855V202.858C196.757 202.146 194.079 201.533 190.79 200.881L190.414 200.783C175.675 197.232 167.743 190.661 167.743 179C167.743 166.274 177.747 157.869 191.775 156.626V146.327H198.878V156.566C212.551 157.81 223.206 166.452 223.62 179.533H213.321C212.551 171.542 206.869 166.866 198.878 165.86V165.917C196.573 165.529 194.147 165.612 191.775 166.051V165.919C182.777 167.103 178.042 172.549 178.042 178.29C178.042 183.93 181.4 188.339 190.943 190.864C193.048 191.584 195.682 192.234 198.878 192.658V192.792L200.713 193.207C215.925 196.876 224.448 203.151 224.448 215.581C224.448 229.846 212.848 237.6 198.878 238.666V248.905Z",
    fill: "#05B595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_25",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 113,
    width: 171,
    height: 94
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.98 183.04C143.571 182.876 129.988 186.107 112.527 196.544C111.051 194.702 117.05 189.544 116.023 187.657C116.03 184.91 127.041 178.127 127.044 176.636C154.595 157.351 184.901 116.023 195.921 113.268C212.398 127.478 241.497 158.218 273.064 179.393C273.11 180.46 273.047 180.536 273.064 182.151C273.058 184.907 275.827 186.855 275.819 190.414C271.697 185.883 282.304 194.065 282.279 194.521C263.735 204.127 248.133 207.172 234.065 206.302C218.379 205.332 205.271 199.479 193.411 194.184C192.959 193.982 192.508 193.781 192.06 193.581C179.552 188.006 168.289 183.232 154.98 183.04Z",
    fill: "#2E3035"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.571 195.918L195.918 113.265L113.265 195.918L195.918 278.571L278.571 195.918ZM198.88 248.905H191.777V238.606C177.69 237.363 166.029 229.017 165.614 215.225H175.914C176.979 222.624 181.537 228.248 191.777 229.373V229.284C195.37 229.986 198.427 229.8 200.867 229.223C210.407 227.923 214.152 222.791 214.152 216.409C214.152 209.899 210.955 205.755 199.236 202.914L198.88 202.855V202.858C196.759 202.146 194.082 201.533 190.792 200.881L190.416 200.783C175.677 197.232 167.746 190.661 167.746 179C167.746 166.274 177.748 157.869 191.777 156.626V146.326H198.88V156.566C212.554 157.81 223.208 166.452 223.622 179.533H213.323C212.554 171.542 206.871 166.866 198.88 165.86C196.595 165.547 194.151 165.631 191.777 166.02V165.919C182.78 167.103 178.045 172.549 178.045 178.29C178.045 183.733 181.171 188.029 189.966 190.592C192.187 191.454 195.124 192.249 198.88 192.721V192.792L200.715 193.206C215.928 196.876 224.451 203.15 224.451 215.581C224.451 229.846 212.849 237.6 198.88 238.666V248.905Z",
    fill: "#00FEB5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtusdn);
export default __webpack_public_path__ + "static/media/usdtusdn.25f0d721370567615443a40eaa32d78d.svg";
export { ForwardRef as ReactComponent };